import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from './index'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTracker = (state: AppState) => state.taskTracker

export {
  selectTaskTrackerProjects,
  selectTaskTrackerActiveProjectId,
  selectTaskTrackerLoadingProjects,
  selectTaskTrackerProjectsError,
  selectTaskTrackerCreatingProject,
  selectTaskTrackerCreateProjectError,
  selectTaskTrackerReorderingProjects,
  selectTaskTrackerReorderingBoardsProjectId,
  selectTaskTrackerActiveProject,
  selectTaskTrackerProjectById,
} from './projects/projects.selectors'

export {
  selectTaskTrackerBoardReloadToken,
  selectTaskTrackerBoardKanban,
  selectTaskTrackerBoardColumns,
  selectTaskTrackerBoardKanbanStickerRows,
  makeSelectTaskTrackerBoardKanbanStickerRows,
} from './boardKanban/boardKanban.selectors'

export { selectTaskTrackerBoardStickerFilters } from './boardStickerFilters/boardStickerFilters.selectors'

export {
  selectTaskTrackerBoardFilterStickersReloadToken,
  selectTaskTrackerBoardFilterStickers,
  selectTaskTrackerBoardAccessibleStickerRows,
  selectTaskTrackerBoardAllStickerRows,
  type TaskTrackerBoardFilterStickerRow,
} from './boardFilterStickers/boardFilterStickers.selectors'

export { selectTaskTrackerBoardEdit } from './boardEdit/boardEdit.selectors'

export {
  selectTaskTrackerBoardStickersTab,
  makeSelectTaskTrackerBoardStickerRows,
} from './boardStickersTab/boardStickersTab.selectors'

export { selectTaskTrackerBoardAutomations } from './boardAutomations/boardAutomations.selectors'

export { selectTaskTrackerBoardRecurringTasks } from './boardRecurringTasks/boardRecurringTasks.selectors'

export { selectTaskTrackerColumnPagination } from './columnPagination/columnPagination.selectors'

export { selectTaskTrackerTaskDrawer } from './taskDrawer/taskDrawer.selectors'

export { selectTaskTrackerProjectEdit } from './projectEdit/projectEdit.selectors'

export { selectTaskTrackerFiltersCatalog } from './filtersCatalog/filtersCatalog.selectors'

export { selectTaskTrackerColumnSort } from './columnSort/columnSort.selectors'

export { selectTaskTrackerProjectMembers } from './projectMembers/projectMembers.selectors'

export { selectTaskTrackerSidebarCollapsed } from './sidebar/sidebar.selectors'
